import React from 'react';
import { getDateLocation } from '../../../common/search/job';
import type { JobAd } from '../../../types';

type JobLocationProps = {
    ad: JobAd;
    className?: string;
};

export function JobLocation(props: JobLocationProps) {
    const { ad, className = '' } = props;

    const isDeadLineToday = Boolean(
        ad.labels?.some((label) => label.id === 'siste_frist'),
    );
    const dateLocationFormatted = getDateLocation(ad, isDeadLineToday);

    return (
        <div className={`text-s s-text-subtle ${className}`}>
            <span>{dateLocationFormatted}</span>
        </div>
    );
}
